import { ACCEPTED_PROJECT_PROCESS, ACCEPTED_PROJECT_PROCESS_FAIL, ACCEPTED_PROJECT_PROCESS_SUCCESS, DEL_PROJECT_PROCESS, DEL_PROJECT_PROCESS_FAIL, DEL_PROJECT_PROCESS_SUCCESS, DESELECT_GP, GET_GPP_BYGPID, GET_GPP_BYGPID_FAIL, GET_GPP_BYGPID_SUCCESS, GET_LIST_PROJECT_PROCESS_ENG, GET_LIST_PROJECT_PROCESS_ENG_FAIL, GET_LIST_PROJECT_PROCESS_ENG_SUCCESS, GET_LIST_PROJECT_PROCESS_REPORT, GET_PROJECT_PROCESS_ENG, GET_PROJECT_PROCESS_ENG_FAIL, GET_PROJECT_PROCESS_ENG_SUCCESS, PROJECT_PROCESS, PROJECT_PROCESS_FAIL, PROJECT_PROCESS_SUCCESS, RESET_GAS_PROCESS_FLAG, SELECT_GP } from "./actionTypes"

//-----------------------------------------------------get PROJECT PROCESS
export const getGppByGpId = gpId => ({
    type: GET_GPP_BYGPID,
    payload: gpId
  })
  
  export const getGppByGpIdSuccess = events => ({
      type:GET_GPP_BYGPID_SUCCESS,
      payload:events
  })
  
  export const getGppByGpIdFail= error =>({
      type:GET_GPP_BYGPID_FAIL,
      payload:error
  })

  export const selectGp = (page,selectArr) => ({
    type: SELECT_GP,
    payload: {page:page,selectArr:selectArr}
  })
  export const deselectGp = () => ({
    type: DESELECT_GP
  })

//----------------------------------------------------- PROJECT PROCESS
export const projectProcess = values =>({
  type:PROJECT_PROCESS,
  payload: values
})

export const projectProcessSuccess = events =>({
  type: PROJECT_PROCESS_SUCCESS,
  payload: events
})

export const projectProcessFail = error =>({
  type: PROJECT_PROCESS_FAIL,
  payload: error
})

  //-----------------------------------------------------get list PROJECT PROCESS
  export const getListProjectProcessEng = values => ({
    type: GET_LIST_PROJECT_PROCESS_ENG,
    payload: values
  })


  export const getListProjectProcessReport = values => ({
    type: GET_LIST_PROJECT_PROCESS_REPORT,
    payload: values
  })
  
  export const getListProjectProcessEngSuccess = events => ({
      type:GET_LIST_PROJECT_PROCESS_ENG_SUCCESS,
      payload:events
  })
  
  export const getListProjectProcessEngFail= error =>({
      type:GET_LIST_PROJECT_PROCESS_ENG_FAIL,
      payload:error
  })

  export const getProjectProcessEng = values => ({
    type: GET_PROJECT_PROCESS_ENG,
    payload: values
  })
  export const getProjectProcessEngSuccess = events => ({
    type:GET_PROJECT_PROCESS_ENG_SUCCESS,
    payload:events
})

export const getProjectProcessEngFail= error =>({
    type:GET_PROJECT_PROCESS_ENG_FAIL,
    payload:error
})
//-----------------------------------------------------delete PROJECT PROCESS
export const deleteProjectProcess = gppId => ({
  type: DEL_PROJECT_PROCESS,
  payload: gppId
})

export const deleteProjectProcessSuccess = events => ({
    type:DEL_PROJECT_PROCESS_SUCCESS,
    payload:events
})

export const deleteProjectProcessFail= error =>({
    type:DEL_PROJECT_PROCESS_FAIL,
    payload:error
})

//-----------------------------------------------------accepted PROJECT PROCESS
export const acceptedProjectProcess = gppId => ({
  type: ACCEPTED_PROJECT_PROCESS,
  payload: gppId
})

export const acceptedProjectProcessSuccess = events => ({
    type:ACCEPTED_PROJECT_PROCESS_SUCCESS,
    payload:events
})

export const acceptedProjectProcessFail= error =>({
    type:ACCEPTED_PROJECT_PROCESS_FAIL,
    payload:error
})

  //-----------------------------------------------------Reset
export const resetGasProcessFlag = () => {
  return {
    type: RESET_GAS_PROCESS_FLAG,
  }
}